export enum Brand {
  GRUBHUB = 'grubhub',
  SEAMLESS = 'seamless',
}

export enum BrandDisplayName {
  GRUBHUB = 'Grubhub',
  SEAMLESS = 'Seamless',
}
